export const dataEvaluation = [
  {
    id: "อาจารย์ที่ปรึกษาประจำชั้น", // i18n-ignore (data: evaluation type value, translated at render)
    name: "อาจารย์ที่ปรึกษาประจำชั้น", // i18n-ignore (data: evaluation type value, translated at render)
  },
  {
    id: "อาจารย์ที่ปรึกษาประจำรายวิชา", // i18n-ignore (data: evaluation type value, translated at render)
    name: "อาจารย์ที่ปรึกษาประจำรายวิชา", // i18n-ignore (data: evaluation type value, translated at render)
  },
  {
    id: "อาจารย์ที่ปรึกษาวิทยานิพนธ์", // i18n-ignore (data: evaluation type value, translated at render)
    name: "อาจารย์ที่ปรึกษาวิทยานิพนธ์", // i18n-ignore (data: evaluation type value, translated at render)
  }
];
//
